import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import swal from 'sweetalert';
import { clearLocalStorageAndLogout } from '../store/actions/AuthAction'
import ApiService from '../services/ApiService';

const AuthenticateRoute = ({ children, roles }) => {
	const token = ApiService.getToken();
	const location = useLocation();
	const dispatch = useDispatch();
	const permissions = useSelector(state => state.auth.userPermissions)
	const userDetail = useSelector(state => state.auth.userDetail)


	const checkUserAcessibility = (acess) => {
		let totalPermission = Object.entries(permissions).map(obj => obj[0]);
		if (acess === '') {
			return true
		}
		if (totalPermission.indexOf(acess) !== -1) {
			return permissions[acess]['view']
		}
		return false
	}

    
	if (!token) {
		// user is not authenticated
		return <Navigate to="/login" replace={true} />;
	} else if (Object.keys(permissions).length == 0) {
		swal("You don't have enough permissions", {
			icon: 'error'
		}).then(() => {
			dispatch(clearLocalStorageAndLogout())
		})
	} else if (token && !checkUserAcessibility(roles)) {
		return <Navigate to={permissions['DASHBOARD'] && permissions['DASHBOARD']['view'] ? "/dashboard" : permissions['RTM'] && permissions['RTM']['view'] ? "/renewal-tracking" : "/rbdm-th-dashbaord"} replace={true} />;
	}
	return children;
}

export default AuthenticateRoute